$(document).ready(function(){

	initDimstrap();

	// $(window).resize(function() {
	// 	initDimstrap();
	// });

	// Detecta los reCaptcha y lo hace responsive
	if($(".g-recaptcha").length != 0){
		responsiveCAPTCHA();

		$(window).resize(function(){
			responsiveCAPTCHA();
		});
	}

	// Tooltips
	if($('.tooltip').length != 0){
		$('.tooltip').tooltipster({
		    animation: 'fade',
	   		delay: 70,
	   		maxWidth: 240
		});
	}

	// Gestión de skyads laterales
	if(($('.skyad').length != 0) && (isMobile() == false)){
		var generalContainer = '.container';
		var mainMenu = '.botbar';
		var maxScroll = 'footer';

		// 0 = distance from general container
		// 1 = distance from top
		// 2 = banner width (not modify)
		// 3 = banner height (not modify)
		var sizes = [10, 20, 160, 600];

		initSkyad(generalContainer, mainMenu, sizes);

		$(window).resize(function(){
			initSkyad(generalContainer, mainMenu, sizes);
		});

		$(window).scroll(function(){
			updateSkyadDistance(maxScroll, mainMenu, sizes);
		});
	}

	// FORMULARIOS

	// Detecta los textarea y les da autosize
	autosize($('textarea'));

	// Detecta los input number y solo les permite entrar números con .
	$('input[type="number"]').keypress(function(e){
		if(isNaN(this.value+""+String.fromCharCode(e.charCode))){
			return false;
		}
	}).on("cut copy paste",function(e){
		e.preventDefault();
	});

	// Detecta los select y los sustituye por dropdown
	$('select').niceSelect();

	// Detecta los campos requeridos
	if($('.input-field.required').length != 0){
		$('.input-field.required').each(function(){
			var current_required = $(this);

			if(!current_required.hasClass('checkbox')){
				current_required.find('label').html(current_required.find('label').html()+'<span>*</span>');
			}
		});
	}

	// Detecta los checkbox y gestiona sus valores
	if($('input[type="checkbox"]').length != 0){
		$('input[type="checkbox"]').click(function(){
			if($(this).val() == 0){
				$(this).val(1);
				$(this).parent().removeClass('error');
			}
			else{
				$(this).val(0);
			}
		});
	}

	// Detecta los input file y los cambia por un botón regular
	if($('input[type="file"]').length != 0){
		var count = 0;
		$('input[type="file"]').each(function(){
			var current_input = $(this);
			current_input.css('display', 'none');

			$('<a href="javascript:void(0);" class="btn upload-file wide" id="upload'+count+'"><i class="fa fa-upload"></i><span>Seleccionar</span></a>').insertBefore(current_input);

			var new_btn = $('#upload'+count);

			$('#upload'+count).click(function(){
				current_input.click();
			});

			current_input.change(function(e){
				var filename = e.target.files[0].name;
				var total_chars = filename.length;

				if(total_chars > 20){
					filename = filename.substring(0, 20)+'...';
				}

				new_btn.find('span').html(filename);
            });

            count++;
		});
	}

	// Valida los formularios
	if($('.validation').length != 0){
		var count = 0;

		$('.validation').each(function(){
			$(this).attr('form-id', count);
			$(this).find('.submit-form').attr('validate-form', count);
			$(this).find('.submit-form').click(formValidation);

			count++;
		});
	}
});




////////////////////////////////////////
////////////////////////////////////////
////								////
////			FUNCIONES			////
////								////
////////////////////////////////////////
////////////////////////////////////////

window.initDimstrap = function (){

	// Detecta si header es fijo
	if($('.sticky-menu').length){
		var stickyOffset = $('.sticky-menu').offset().top;

		stickyHeader(stickyOffset);

		$(window).scroll(function(){
			stickyHeader(stickyOffset);
		});
	}

	// Columnas iguales (.equal-height)
	if(($('.equal-height').length != 0) && (isMobile() == false)){
		equalHeightCol();

		$(window).resize(function(){
			equalHeightCol();
		});
	}

	// Centrar contenido vertical (.vertical-align)
	// SOLO EN EQUAL-HEIGHT!!!
	if(($('.vertical-align').length != 0) && (isMobile() == false)){

		$('.vertical-align').each(function(){

			if($(this).children('.content-vertical-align').length == 0){
				var current_content = $(this).html();
				$(this).html('');
				$('<div class="content-vertical-align">'+current_content+'</div>').appendTo($(this));
			}
		});
	}

	// Gestión de dropdowns
	$('.dropdown .dropdown-open').click(function(e){

		$('.dropdown.active').each(function(){
			var currentDropdown = $(this);
			if(!$(e.currentTarget).parent().is(currentDropdown)){
				currentDropdown.removeClass('active');
			}
		});

		$(e.currentTarget).parent().toggleClass('active');
		e.stopPropagation();
	});

	// Cierra dropdown si se hace click fuera
	$(document).on('click', function(e) {
		if ($(e.target).is('.dropdown.active') === false) {
			$('.dropdown.active').removeClass('active');
		}
	});
}

window.stickyHeader = function (stickyOffset){
	var sticky = $('.sticky-menu'),
	scroll = $(window).scrollTop();

	if(scroll >= stickyOffset){
		sticky.addClass('fixed');
		$('.all').css('padding-top', sticky.outerHeight(true) + 'px');
	}
	else{
		sticky.removeClass('fixed');
		$('.all').css('padding-top', 0);
	}
}



window.fixFooter = function (){
    $('.footer-fix').css('height', $('footer').outerHeight(true) + 'px');
}


window.height169 = function (element){
    $(element).each(function(){

    	if(!$(this).hasClass('circle-image')){
			var img = $(this).find('img');
			var element_width_img = $(this).innerWidth();
			var element_height_img = $(this).innerHeight();

			var element_width  = parseInt($(this).innerWidth());
			var element_height = parseInt((element_width/16)*9);

			$(this).css({
				'height': element_height+'px',
				'overflow': 'hidden'
			});

			img.removeAttr('style');
			img.css('min-width', '100%');
			img.css('min-height', element_height+'px');

			if(element_height_img >= element_height){
				img.css({
					'position': 'relative',
		        	'height': 'auto',
		        	'width': '100%',
		        	'top': '50%',
		        	'transform': 'translateY(-50%)',
		        	'-o-transform': 'translateY(-50%)',
		        	'-moz-transform': 'translateY(-50%)',
		        	'-webkit-transform': 'translateY(-50%)'
				});
			}

			if(element_height_img < element_height){
				img.css({
					'position': 'relative',
		        	'height': '100%',
		        	'width': 'auto',
		        	'left': '50%',
		        	'transform': 'translateX(-50%)',
		        	'-o-transform': 'translateX(-50%)',
		        	'-moz-transform': 'translateX(-50%)',
		        	'-webkit-transform': 'translateX(-50%)'
				});
			}
    	}
    });
}



window.responsiveCAPTCHA = function (){
	var recaptcha = $(".g-recaptcha");

	// Note that 414 is the screen's width value where
	//the script starts to work, feel free to change it
	var responsiveScreen = 414;

	if($(window).width() <= responsiveScreen){
		var newScaleFactor = recaptcha.parent().innerWidth() / 304; // 304 = default reCAPTCHA width, not modify
		recaptcha.css('transform', 'scale(' + newScaleFactor + ')');
		recaptcha.css('transform-origin', '0 0');

		// Adjust all reCAPTCHA's height after scaling
		setTimeout(function(){
			recaptcha.each(function(){
				$(this).css('height', $(this).find('div:first-child')[0].getBoundingClientRect().height+'px');
			});
		}, 60);
	}
	else {
		recaptcha.css('transform', 'scale(1)');
		recaptcha.css('transform-origin', '0 0');
	}
}



window.equalHeightCol = function (){
	$('.equal-height').each(function(){
		var current = $(this);
		var count = 0;
		var heights = [];
		var max_height = 0;
		var paddings = [];
		var padding = 0;

		current.children('[class^="col-"], [class*="col-"]').each(function(){
			var current_col = $(this);
			paddings[count] = ($(this).innerHeight() - $(this).height())/2;

			if(current_col.children('.col-equal-height').length == 0){
				var col_content = current_col.html();
				$(this).html('');
				$('<div class="col-equal-height">'+col_content+'</div>').appendTo($(this));
			}

			heights[count] = current_col.children('.col-equal-height').outerHeight(true);
			count++;
		});

		max_height = Math.max.apply(null, heights);

		for(var i = 0; i < heights.length; i++){

			if(heights[i] == max_height){
				padding = paddings[i];
			}
		}

		max_height = max_height + padding*2;

		current.children('[class^="col-"], [class*="col-"]').each(function(){
			$(this).css('height', max_height+'px');
		});
	});
}


window.formValidation = function (e){
	var submit_btn = $(e.target);
	var form_id = submit_btn.attr('validate-form');

	$('form').each(function(){
		if($(this).attr('form-id') == form_id){
			var current_form = $(this);

			current_form.find('.input-field').each(function(index){
				var current_input = $(this);

				// campos requeridos
				if(current_input.hasClass('required')){

					var elements = [
						current_input.find('input[type="text"]'),
						current_input.find('input[type="number"]'),
						current_input.find('input[type="email"]'),
						current_input.find('input[type="password"]'),
						current_input.find('input[type="file"]'),
						current_input.find('input[type="checkbox"]'),
						current_input.find('textarea'),
						current_input.find('select')
					];

					for(var i = 0; i < elements.length; i++){

						if(elements[i].prop('type') != 'checkbox'){

							if(elements[i].length > 0){

								if(current_input.find('label .error-msg').length > 0){
									current_input.find('label .error-msg').remove();
								}

								if($.trim(elements[i].val()) == ''){
									elements[i].val('');

									$('<span class="error-msg">&#8212; Obligatorio</span>').appendTo(current_input.find('label'));
									current_input.addClass('error');
								}
								else{
									current_input.removeClass('error');
									validateInput(current_input);
								}
							}
						}
						else{
							if(!elements[i].is(":checked")){
								current_input.addClass('error');
							}
							else{
								current_input.removeClass('error');
							}
						}
					}
				}
				else{
					validateInput(current_input);
				}
			});
		}
	});
}



window.validateInput = function (element){

	var field = null;

	if(element.hasClass('error')){

		if(element.find('label .error-msg').length > 0){
			element.find('label .error-msg').remove();
		}

		element.removeClass('error');
	}


	if(element.find('input[type="email"]').length > 0){
		field = 'email';
	}
	else if(element.find('input[type="number"]').length > 0){
		field = 'number';
	}


	switch(field){

		// valida email
		case 'email':

			if($.trim(element.find('input[type="email"]').val().replace(/\s+/g, '')) != ''){

				if(!validateEmail(element.find('input[type="email"]').val())){
					$('<span class="error-msg">&#8212; Email erróneo</span>').appendTo(element.find('label'));
					element.addClass('error');
				}
			}

			break;


		// valida numero
		case 'number':

			if($.trim(element.find('input[type="number"]').val().replace(/\s+/g, '')) != ''){

				if(!validateNumber(element.find('input[type="number"]').val())){
					$('<span class="error-msg">&#8212; Escribe un número</span>').appendTo(element.find('label'));
					element.addClass('error');
				}
			}

			break;
	}
}


window.validateEmail = function (email){
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if(!emailReg.test(email)){
        return false;
    }
    else{
        return true;
    }
}


window.validateNumber = function (element){
    return /^-?\d*[.]?\d*$/.test(element);
}


window.isMobile = function (){
	try{
		if(/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)){
			return true;
		};

		return false;
	}
	catch(e){
		console.log("Error in isMobile");
		return false;
	}
}



window.initSkyad = function (nextToElement, distanceTop, sizes){
	var distanceFromWindow = $(window).width() - ($(nextToElement).offset().left + $(nextToElement).width());

	if(distanceFromWindow > (160 + sizes[0])){
		$('.skyad').css({
			'display': 'block',
			'bottom': $(window).height() - sizes[3] - ($(distanceTop).outerHeight(true) + sizes[1]) + 'px',
			'position': 'fixed',
			'z-index': '1',
			'width': sizes[2] + 'px'
		});

		$('.sky-left').css({
			'left': (distanceFromWindow - sizes[2] - sizes[0]) + 'px',
			'text-align': 'right'
		});

		$('.sky-right').css({
			'right': (distanceFromWindow - sizes[2] - sizes[0]) + 'px',
			'text-align': 'left'
		});
	}
	else{
		$('.skyad').css({
			'display': 'none'
		});
	}
}



window.updateSkyadDistance = function (elem, distanceTop, sizes){

	if($('.skyad').is(':visible')){
		var elemTopDistance = $(elem).offset().top - $(window).scrollTop();
		var elemTotalDistance = (sizes[1] * 2) + sizes[3];

		if((elemTopDistance - (sizes[1] * 3.75)) <= elemTotalDistance){
			$('.skyad').css({
				'bottom': $(window).height() - elemTopDistance + (sizes[1] * 2) + 'px'
			});
		}
		else{
			$('.skyad').css({
				'bottom': $(window).height() - sizes[3] - ($(distanceTop).outerHeight(true) + sizes[1]) + 'px'
			});
		}
	}
}
